import {qspost} from '@/plugins/axios'
import {ONLINEHOST_EMOF} from "@/config";

/*
 * 首页-个人会员和单位会员列表
 * */
export const getMemberList = (orgId,user_type,page,limit,isAll
    = 0) => qspost('bigscreen/member_program/memberList', {orgId,user_type,page,limit,isAll})

/*
 * 四个数据统计
 * */
export const getMemberCount = (orgId,orgFid) => qspost('bigscreen/member_program/index', {orgId,orgFid})

/*
 * 会员管理制度
 * */
export const getMemberManagement = (orgId,page,limit) => qspost('bigscreen/member_program/managementQuery', {orgId,page,limit})

/*
 * 会员管理制度
 * */
export const getMemberManagementDetail = (id) => qspost('bigscreen/member_program/managementDetail', {id})

/*
 * 会员入会流程
 * */
export const getJoinProcessDetail = (orgId,orgFid='') => qspost('bigscreen/member_program/getJoinProcessDetail', {orgId,orgFid})

/*
 * 服务列表
 * */
export const getMemberServices = (orgId) => qspost('bigscreen/member_program/services', {orgId})

/*
 * 服务列表
 * */
export const getMemberServiceContents = (orgId,search_type,page,limit
) => qspost('bigscreen/member_program/servicesQuery', {orgId,search_type,page,limit})

/*
 * 服务列表
 * */
export const getMemberServiceContentDetail = (id) => qspost('bigscreen/member_program/servicesDetail', {id})


/*
 * 服务列表
 * */
export const getInfo = (type,link_id) => qspost('/home/Iterative/getInfo', {type,link_id})

/*
 * 通知
 * 列表参数：
int       page            默认第一页
int       limit           默认每页十条
string    searchTitle     搜索标题
int       subsiteId       * 1、会员管理，2、益会宝，3、益宣宝，4、益书宝，5、知识管理，6、绩效管理，7、电子书
详情参数：
int     id      主键
 * */
export const getHomeNoticeList = (searchTitle,page,limit,subsiteId=1) => qspost(`${ONLINEHOST_EMOF}/home/Notice/noticeList`, {searchTitle,page,limit,subsiteId})

export const getHomeNewsList = (searchTitle,page,limit,subsiteId=1) => qspost(`${ONLINEHOST_EMOF}/home/News/newsList`, {searchTitle,page,limit,subsiteId})
